import * as React from 'react';
import { ACTION_BAR_HEIGHT, HEADER_HEIGHT } from '../../data-grid.constants';

interface OverlayProps {
  children: React.ReactNode;
}

export const Overlay: React.FC<OverlayProps> = ({ 
  children,
}) => {
  return (
    <div 
      className={`absolute inset-0 z-10 flex items-center justify-center bg-white
        ${ACTION_BAR_HEIGHT ? `top-[${ACTION_BAR_HEIGHT}px]` : ''}
        ${HEADER_HEIGHT ? `top-[${HEADER_HEIGHT}px]` : ''}`}
    >
      <div className="flex flex-col items-center space-y-2">
        {children}
      </div>
    </div>
  );
};
